/**
 * FMA Browse Agencies Tour Steps
 * Tour for agency search and discovery
 */
import { Step } from "react-joyride";

export const fmaAgenciesSteps: Step[] = [
  {
    target: "body",
    content:
      "Welcome to Agency Search! Find the perfect agency match for your career goals.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tour="search-bar"]',
    content:
      "Use the search bar and filters to narrow agencies by name, state, product type, or specialty.",
    placement: "bottom",
    disableScrolling: true,
  },
  {
    target: '[data-tour="agency-card"]',
    content:
      "Each card shows key details: agency name, location, products offered, and video availability. The crown badge indicates Elite and vetted agencies.",
    placement: "top",
  },
  {
    target: '[data-tour="view-profile-btn"]',
    content:
      "Click 'View Profile' to see detailed information, culture/values, and to book an interview.",
    placement: "top",
    offset: 100,
  },
];
